var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33568",
    "data-name": "Group 33568",
    transform: "translate(18586 21844)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9771",
    "data-name": "Rectangle 9771",
    width: 24,
    height: 24,
    transform: "translate(-18586 -21844)",
    fill: "#808080",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component_60_214",
    "data-name": "Component 60 \\u2013 214",
    transform: "translate(-18582.105 -21842)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9770",
    "data-name": "Rectangle 9770",
    width: 1.351,
    height: 20,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M8.172,12.631A2.229,2.229,0,0,1,5.945,10.4V9.658H0V1.486H7.432a.741.741,0,0,1,.74.74.741.741,0,0,0-.74-.74H0V0H7.432A2.228,2.228,0,0,1,9.658,2.227v.746h6.688v9.658Zm-.74-2.23a.742.742,0,0,0,.74.744h6.691v0H8.172A.742.742,0,0,1,7.432,10.4Z",
    transform: "translate(1.352 0.002)",
    fill: "#808080",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagDisabled);
export default __webpack_public_path__ + "static/media/flag-disabled.51d953ee8cebe928e8eaeb2042b34e7d.svg";
export { ForwardRef as ReactComponent };